import React from 'react';
import axios from 'axios';
const WithConfig = ({ children, default_config, Context, }) => {
    const [config, setConfig] = React.useState({});
    React.useEffect(() => {
        void axios
            .get('/config.json')
            .then(({ data }) => {
            if (!data ||
                typeof data !== 'object' ||
                Array.isArray(data) ||
                data === null) {
                throw new Error('WithConfig: Malformed config detected.');
            }
            setConfig(Object.assign(Object.assign({}, default_config), data));
        })
            .catch((err) => {
            throw err;
        });
    }, [default_config]);
    if (Object.keys(config).length > 0) {
        return React.createElement(Context.Provider, { value: config }, children);
    }
    return null;
};
export default WithConfig;
//# sourceMappingURL=index.js.map